import { IPerformanceEvaluationDefinitionScopeOfWorks } from "models/ScopeOfWorkModel";
import { BaseService } from "./base.service";

class PerformanceEvaluationDefinitionScopeOfWorkServiceInternal extends BaseService {
	getApprovedActiveScopeOfWorksList = async (): Promise<
		IPerformanceEvaluationDefinitionScopeOfWorks[]
	> =>
		this.callApi<IPerformanceEvaluationDefinitionScopeOfWorks[]>(
			`PerformanceEvaluationDefinitionScopeOfWork/GetApprovedActiveScopeOfWorks`,
			"GET"
		);
}

export const PerformanceEvaluationDefinitionScopeOfWorkService =
	new PerformanceEvaluationDefinitionScopeOfWorkServiceInternal();
